<template>
  <v-snackbar
  v-model="notification"
  :color="notificationText.type || 'primary'"
  auto-height
  :timeout="notificationText.timeout || 3000"
  >
  <v-icon class="mr-4" style="color:rgba(0,0,0,0.3);">check_circle</v-icon>
  {{ notificationText.text }}
    <v-btn
        flat
        @click="notification = false"
        icon
      >
      <v-icon right class="ml-3" style="color:rgba(0,0,0,0.3);">cancel</v-icon>
      </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'AppNotifications',
  data () {
    return {
    }
  },
  computed: {
    hasNotificationsPending () {
      // boolean for checking if we should keep running the snackbar
      return this.notificationQueue.length > 0
    },
    notificationText () {
      // get the current item from the store
      return this.$store.getters.getNotificationText
    },
    notificationQueue () {
      // get the queus from the store
      return this.$store.getters.getNotificationQueue
    },
    notification: {
      // reactive notification state. When the snakcbar is closed or autocloses
      // this is set back to false
      // getter
      get: function () {
        return this.$store.getters.getNotificationState
      },
      // setter
      set: function (newValue) {
        this.$store.dispatch('setNotificationState', newValue)
      }
    }
  },
  watch: {
    notification () {
      // watch for changes to notification,
      // if it's not showing and items are in the queue then showit
      if (!this.notification && this.hasNotificationsPending) {
        // first of all get the next queue item into the current notificationText
        this.$store.dispatch('shiftNotificationQueue')
        this.$nextTick(() => {
          // when done lets popup and show it
          this.$store.dispatch('setNotificationState', true)
        })
      }
    }
  }
}
</script>
